/* Words for the logins view's record values (LOGIN TRACKING, 2026-09-03).
 * Deterministic, model-free — the same value always gives the same words;
 * the sentences that hold them live in the phrasebook (login.* and
 * session.*). Kept out of the page file so it exports only components. */

export type EndedBy = 'logout' | 'idle' | 'admin' | 'expired'
export type Outcome = 'ok' | 'bad_password' | 'locked' | 'unknown_user' | 'inactive'

const pad = (n: number) => String(n).padStart(2, '0')

/** The officer's own clock: the day as the date slot expects it and the
 *  time of day exactly as the record holds it. */
export function whenParts(iso: string): { day: string; time: string } {
  const d = new Date(iso)
  if (!Number.isFinite(d.getTime())) return { day: iso, time: '' }
  return {
    day: `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`,
    time: `${pad(d.getHours())}:${pad(d.getMinutes())}`,
  }
}

/** How a session stopped, in words. */
export function endedWords(ended: EndedBy | null, idleHours: number): string {
  switch (ended) {
    case 'logout':
      return 'signed out'
    case 'idle':
      return `ended after ${idleHours} hours of inactivity`
    case 'admin':
      return 'ended by an administrator'
    case 'expired':
      return 'ended when the token expired'
    default:
      return 'ended'
  }
}

/** Why a sign-in attempt was refused, in words. */
export function refusalWords(outcome: Outcome): string {
  switch (outcome) {
    case 'bad_password':
      return 'wrong password'
    case 'locked':
      return 'account locked after repeated failures'
    case 'unknown_user':
      return 'no such account'
    case 'inactive':
      return 'account deactivated'
    default:
      return 'refused'
  }
}
